import { isAnalyticsAllowed } from './consentManager'

type TrackButtonClickMetadata = Record<string, unknown>

interface TrackButtonClickOptions {
  label: string
  location?: string
  value?: string
  section?: string
  metadata?: TrackButtonClickMetadata
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export function trackButtonClick({ label, location, value, section, metadata = {} }: TrackButtonClickOptions): void {
  if (typeof window === 'undefined') return
  if (!isAnalyticsAllowed()) return
  if (!label) return

  const payload: Record<string, unknown> = {
    event: 'button_click',
    button_label: label,
  }

  if (location) {
    payload.button_location = location
  }

  if (value) {
    payload.button_value = value
  }

  if (section) {
    payload.button_section = section
  }

  Object.assign(payload, metadata)

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}
